module.exports = __webpack_public_path__ + "static/media/bars-extended.2daff766.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/features/bars-extended.svg
// module id = 133
// module chunks = 0